import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from 'debounce';

class TextAreaWrapper extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    validationData: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    const { dispatch, onChange } = props;

    this.changed = debounce((...params) => dispatch(onChange(...params)), 250);
  }

  componentWillReceiveProps(nextProps) {
    const oldValue = this.props && this.props.value;
    const newValue = nextProps && nextProps.value;
    if (oldValue && !newValue) {
      this.setState({
        value: '',
      });
    }
  }

  handleChange = (e) => {
    const value = e.target.value;

    this.setState({ value }, () => {
      this.changed({
        ...this.props.validationData,
        value,
      });
    });
  }

  render() {
    return (
      <textarea
        key='user-intended-use'
        name='user-intended-use'
        id='user-intended-use'
        tabIndex={4}
        value={this.state.value}
        onChange={this.handleChange}
      />
    );
  }
}

export default TextAreaWrapper;



// WEBPACK FOOTER //
// ./src/components/lib/TextArea.js